module.exports = __webpack_public_path__ + "static/media/header-img-all.e3adf3da.png";